export default "__VITE_ASSET__Ba0$Zlel__"